import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { Icon, Paper, Typography } from '@mui/material';
import * as React from 'react';

export function ContactEmail(props: {
}) {

    return <a href="mailto:agata@park-baczynskiego.pl?subject=Zapytanie" className="a-no-underline">
        <Paper elevation={2} className="p-2 " square>
            <Typography variant="subtitle2"
                className="text-black"
            >
                <ContactSupportIcon sx={{ mr: 1, color: 'gold' }} />
                agata@park-baczynskiego.pl
            </Typography>
            <div className="bg-gradient-gold effectShadowLight-silver d-none"
                style={{
                    zIndex: 4,
                    position: 'relative',
                    height: '2px',
                    width: '100%',
                }} />
        </Paper>
    </a>
}
export function ContactPhone(props: {
}) {

    return <a href="callto:+48509958294" className="a-no-underline">
        <Paper elevation={2} className="p-2 " square>
            <Typography variant="subtitle2"
                className="text-black"
            >
                <ContactSupportIcon sx={{ mr: 1, color: 'gold' }} />
                +48 509 958 294
            </Typography>
            <div className="bg-gradient-gold effectShadowLight-silver d-none"
                style={{
                    zIndex: 4,
                    position: 'relative',
                    height: '2px',
                    width: '100%',
                }} />
        </Paper>
    </a>
}
export function ContactInsta(props: {
}) {

    return <a href="https://www.instagram.com/park_baczynskiego/" className="a-no-underline"
        target='_blank'
    >
        <Typography variant="subtitle2"
            className="text-black"
        >
            <img src="./img/icons/instagram.png" alt="instagram" width='55' />
        </Typography>
    </a>
}
export function ContactFB(props: {
}) {

    return <a href="https://www.facebook.com/profile.php?id=61579608514819" className="a-no-underline"
        target='_blank'
    >
        <Typography variant="subtitle2"
            className="text-black"
        >
            <img src="./img/icons/facebook.png" alt="facebook" width='55' />
        </Typography>
        <div className="bg-gradient-gold effectShadowLight-silver d-none"
            style={{
                zIndex: 4,
                position: 'relative',
                height: '2px',
                width: '100%',
            }} />
    </a>
}